var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fullscreen-overlay-frame',{attrs:{"title":_vm.data?.name,"icon":"feed","color":"primary","centered":"","closable":""},on:{"close":_vm.closeOverlay},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticStyle:{"height":"calc(100% - 140px)"},attrs:{"id":'hubspot-form-' + _vm.data.formId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }